"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var getDuration = function getDuration(time) {
  var secs = Math.round(time);
  var hours = Math.floor(secs / (60 * 60));
  var divisorForMinutes = secs % (60 * 60);
  var minutes = Math.floor(divisorForMinutes / 60);
  var divisorForSeconds = divisorForMinutes % 60;
  var seconds = Math.ceil(divisorForSeconds);
  var formattedTime = '';

  if (hours) {
    formattedTime += "".concat(hours, " ").concat(hours > 1 ? ' hours ' : ' hour ');
  }

  if (minutes) {
    formattedTime += "".concat(minutes, " ").concat(minutes > 1 ? ' minutes ' : ' minute ');
  }

  if (seconds) {
    formattedTime += "".concat(seconds, " ").concat(seconds > 1 ? ' seconds ' : ' second ');
  }

  return formattedTime;
};

var _default = getDuration;
exports.default = _default;